import React from 'react';

import {SLOTS_MAPPING} from '../../constants/ad-slots';
import {usePopularArticles} from '../../hooks/use-populararticles';
import AdSlot from '../ad-slot';
import {PopularNews} from '../popular-news';

import styles from './trend-sidebar.module.css';

const TrendSidebar = () => {

  const data = usePopularArticles();

  return (
    <aside className={styles.sidebar}>
      <AdSlot slot={SLOTS_MAPPING.Desktop_Right1} className="rootInSidebar" />
      <PopularNews newsData={data} />
      <AdSlot slot={SLOTS_MAPPING.Desktop_Right3} className="rootInSidebar" />
    </aside>
  );
};

export {TrendSidebar};
